import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { StateParams } from "@ui/navigation/routes";
import { isNotNil } from "@utils/assert";

export function useStateParams<R extends keyof StateParams>(): Partial<StateParams[R]> {
	const location = useLocation();
	return useMemo(() => {
		if (isNotNil(location.state)) {
			return location.state as Partial<StateParams[R]>;
		}
		return {};
	}, [location]);
}
